import md5 from "md5";
import { getMonthsArray } from "../";

type EnergyRow = {
  id: string;
  ts: string;
  [key: string]: string | number;
};

type EnergyHourly = {
  ts: string;
  consumptionV: number;
};

type MeterData = {
  meter?: string | number;
  data: EnergyHourly[];
};

type EnergyData = {
  monthlyStatementData?: {
    metersData?: MeterData[];
    month?: number;
  };
};

export const energyMonthlyRows = (
  data: EnergyData,
  gettext: (key: string) => string,
) => {
  const rows: Record<string, EnergyRow[]> = {};

  const metersData = data?.monthlyStatementData?.metersData;
  const monthsArray = getMonthsArray(gettext);
  const monthIndex = data?.monthlyStatementData?.month || 0;
  const selectedMonth = monthsArray[monthIndex].value;

  if (Array.isArray(metersData) && metersData.length > 0) {
    metersData.map((objConsumptionData: MeterData): null => {
      const orderNo = objConsumptionData?.meter;
      const orderKey = String(orderNo);

      if (!rows["all"]) {
        rows["all"] = [];
      }

      if (!rows[selectedMonth]) {
        rows[selectedMonth] = [];
      }

      objConsumptionData.data.map((hourlyData: EnergyHourly): null => {
        const rowIndex: Record<string, number> = {};
        const id = md5(hourlyData.ts);
        rowIndex["all"] = rows["all"].findIndex((obj) => obj.id === id);
        rowIndex[selectedMonth] = rows[selectedMonth].findIndex(
          (obj) => obj.id === id,
        );
        if (rowIndex["all"] > -1) {
          rows["all"][rowIndex["all"]][orderKey] = hourlyData.consumptionV;
        } else {
          const row: EnergyRow = {
            id: id,
            ts: hourlyData.ts,
          };
          row[orderKey] = hourlyData.consumptionV;
          rows["all"].push(row);
        }

        if (rowIndex[selectedMonth] > -1) {
          rows[selectedMonth][rowIndex[selectedMonth]][orderKey] =
            hourlyData.consumptionV;
        } else {
          const row: EnergyRow = {
            id: id,
            ts: hourlyData.ts,
          };
          row[orderKey] = hourlyData.consumptionV;
          rows[selectedMonth].push(row);
        }
        return null;
      });

      return null;
    });
  }

  return rows;
};
